import {axios} from '../../libs';
import {defaultsDeep as _defaultsDeep} from 'lodash';
import {chatbotSlice} from '../slices';
import store from '../../store';
import logger from '../../utils/logger';

const Actions = chatbotSlice.actions;
const {dispatch, getState} = store;

let suppressApiWrites = false;

const setSuppressApiWrites = (value) => {
  suppressApiWrites = Boolean(value);
};

const allowApiCall = (callAPI) => callAPI && !suppressApiWrites;

const get = (type = null) => {
  if (type === 'current') {
    return getState().chatbot;
  }
  return (state) => state.chatbot;
};

const getBlocksToReview = (blocks = null) => {
  let variables = [];
  Object.values(blocks ?? getState().chatbot.blocks).forEach((item) => {
    //logger.log(item.type);
    if (item.type === 'inputBlock' || item.type === 'multipleChoiceBlock') {
     // if (item.data?.hasOwnProperty('variable')) {
        variables.push({label: item.data.variable, value: item.data._id, content: item.data._id, id: item.data._id});
     // }
    }else{}
  });
  return variables;
};

/* If there is a need for teleport block variables to be imported
const getBlocksToTeleport = (blocks = null) => {
  let variables = [];
  Object.values(blocks ?? getState().chatbot.blocks).forEach((item) => {
    //logger.log(item.type);
    if (item.type === 'inputBlock' || item.type === 'multipleChoiceBlock') {
     // if (item.data?.hasOwnProperty('variable')) {
        variables.push({label: item.data.variable, value: item.data._id, content: item.data._id, id: item.data._id});
     // }
    }else{}
  });
  return variables;
};*/
const getFileVariables = (blocks = null) => {
  const variables = [];
  Object.values(blocks ?? getState().chatbot.blocks).forEach((item) => {
    if (item.type === 'uploadBlock' && item.data?.variable) {
      variables.push({label: item.data.variable, value: item.data.variable});
    }
    if (item.type === 'inputuploadBlock' && item.data?.uploadVariable) {
      variables.push({label: item.data.uploadVariable, value: item.data.uploadVariable});
    }
    if (item.type === 'documentBlock' && item.data?.variableForUrl) {
      variables.push({label: item.data.variableForUrl, value: item.data.variableForUrl});
    }
    if (item.type === 'aiBlock' && item.data?.outputMode === 'doc' && item.data?.docVariable) {
      variables.push({label: item.data.docVariable, value: item.data.docVariable});
    }
  });
  return variables;
};

const getBlockVariables = (blocks = null) => {
  let variables = [];

  variables.push(
    // {
    //   label: 'email_confrimation_dateofclick',
    //   value: 'email_confrimation_dateofclick',
    //   content: 'Email confirmation Date of click',
    // },
    {
      label: 'email_confrimation_timeofclick',
      value: 'email_confrimation_timeofclick',
      content: 'Email confirmation Time of click',
    },
  );
  Object.values(blocks ?? getState().chatbot.blocks).forEach((item) => {
    if (item.type !== 'conditionBlock') {
      if (item.data?.hasOwnProperty('variable') && !(item.type === 'aiBlock' && item.data?.outputMode === 'multiple' && item.data?.outputMappings?.length)) {

        variables.push({label: item.data.variable, value: item.data._id, content: item.data._id, id: item.data._id});
        if (item.type === 'decisionBlock') {
          variables.push(
            {
              label: `${item.data.variable}-dateofclick`,
              value: item.data.variable,
              content: `${item.data.variable} Date of click`,
            },
            {
              label: `${item.data.variable}-timeofclick`,
              value: item.data.variable,
              content: `${item.data.variable} Time of click`,
            },
          );
        }

      }
      if (item.type === 'calculationBlock') {
        variables.push(
          {
            label: `Today`,
            value: `today`,
            content: `today`,
          },
        );
      }
      if (item.type === 'dataBlock' && item.data.data) {
        Object.entries(item.data.data).forEach(([text, value]) => {
          variables.push({label:value.text, value: value.value, content: item.data.content});
        });
      }
      if (item.type === 'dataBlock' && item.data?.datatype === 'lawyers' && item.data?.lawyers_variable) {
        variables.push({
          label: item.data.lawyers_variable,
          value: item.data.lawyers_variable,
          content: item.data.lawyers_variable,
        });
      }
      if (item.type === 'dataBlock' && item.data?.datatype === 'richtext' && item.data?.richtext_variable) {
        variables.push({
          label: item.data.richtext_variable,
          value: item.data.richtext_variable,
          content: item.data.richtext_variable,
        });
      }
      if (item.type === 'loginBlock') {
          variables.push(
          {
            label: 'firstname',
            value: 'firstname',
            content: 'firstname',
          },
          {
            label: 'lastname',
            value: 'lastname',
            content: 'lastname',
          },
          {
            label: 'phone',
            value: 'phone',
            content: 'phone',
          },
          {
            label: 'email',
            value: 'email',
            content: 'email',
          }, 
          {
            label: 'pid',
            value: 'pid',
            content: 'pid',
          },
          {
            label: 'client_type',
            value: 'client_type',
            content: 'client_type',
          },
          {
            label: 'business_name',
            value: 'business_name',
            content: 'business_name',
          },
          {
            label: 'business_address',
            value: 'business_address',
            content: 'business_address',
          },
          {
            label: 'business_reg_code',
            value: 'business_reg_code',
            content: 'business_reg_code',
          },
        )
      }
      /* calendarBlock / scoroBlock retired
      if (item.type === 'calendarBlock') {
        variables.push(
        {
          label: 'slot',
          value: 'slot',
          content: 'slot',
        },
        {
          label: 'slot_date',
          value: 'slot_date',
          content: 'slot_date',
        },
        {
          label: 'slot_address',
          value: 'slot_address',
          content: 'slot_address',
        },
      )
      }
      if (item.type === 'scoroBlock') {
        variables.push(
        {
          label: 'scoro_invoice',
          value: 'scoro_invoice',
          content: 'scoro_invoice',
        },
        {
          label: 'project_id',
          value: 'project_id',
          content: 'project_id',
        },
      )
      }
      */
      if (item.type === 'paymentBlock') {
        variables.push(
        {
          label: 'invoice_no',
          value: 'invoice_no',
          content: 'invoice_no',
        },
        {
          label: 'payment_success',
          value: 'payment_success',
          content: 'payment_success',
        },
        {
          label: 'pdf_link',
          value: 'pdf_link',
          content: 'pdf_link',
        },
      )
      }
      if (item.type === 'subscriptionBlock') {
        variables.push(
          {
            label: 'subscription_invoice_no',
            value: 'subscription_invoice_no',
            content: 'subscription_invoice_no',
          },
          {
            label: 'subscription_pdf_link',
            value: 'subscription_pdf_link',
            content: 'subscription_pdf_link',
          },
        );
      }
      if (item.type === 'matchBlock') {
        variables.push(
          { label: 'lawyer', value: 'lawyer', content: 'lawyer' },
          { label: 'selected_service_price', value: 'selected_service_price', content: 'selected_service_price' },
          { label: 'partner_email', value: 'partner_email', content: 'partner_email' },
          { label: 'partner_company_name', value: 'partner_company_name', content: 'partner_company_name' },
          { label: 'partner_company_reg_id', value: 'partner_company_reg_id', content: 'partner_company_reg_id' },
          { label: 'partner_company_vat_id', value: 'partner_company_vat_id', content: 'partner_company_vat_id' },
          { label: 'partner_vat', value: 'partner_vat', content: 'partner_vat' },
          { label: 'partner_company_address', value: 'partner_company_address', content: 'partner_company_address' },
          { label: 'partner_hourlyprice', value: 'partner_hourlyprice', content: 'partner_hourlyprice' },
          { label: 'partner_videocall_url', value: 'partner_videocall_url', content: 'partner_videocall_url' },
          { label: 'partner_crm_id', value: 'partner_crm_id', content: 'partner_crm_id' },
          { label: 'lawyer_profile', value: 'lawyer_profile', content: 'lawyer_profile' },
          { label: 'lawyer_img', value: 'lawyer_img', content: 'lawyer_img' },
        );
      }
      if (item.type === 'matchV2Block') {
        variables.push(
          { label: 'partner_name', value: 'partner_name', content: 'partner_name' },
          { label: 'partner_company_name', value: 'partner_company_name', content: 'partner_company_name' },
          { label: 'partner_crm_id', value: 'partner_crm_id', content: 'partner_crm_id' },
          { label: 'selected_service_price', value: 'selected_service_price', content: 'selected_service_price' },
          { label: 'client_type', value: 'client_type', content: 'client_type' },
          { label: 'legal_field_ids', value: 'legal_field_ids', content: 'legal_field_ids' },
          { label: 'subject', value: 'subject', content: 'subject' },
        );
      }
      if (item.type === 'classifyBlock') {
        variables.push(
          { label: 'legal_field_ids', value: 'legal_field_ids', content: 'legal_field_ids' },
          { label: 'subject', value: 'subject', content: 'subject' },
        );
      }
      if (item.type === 'invoiceBlock') {
        variables.push(
          // Invoice data
          { label: 'invoice_id', value: 'invoice_id', content: 'invoice_id' },
          { label: 'invoice_no', value: 'invoice_no', content: 'invoice_no' },
          { label: 'amount', value: 'amount', content: 'amount' },
          { label: 'amount_total', value: 'amount_total', content: 'amount_total' },
          { label: 'prepayment_applied', value: 'prepayment_applied', content: 'prepayment_applied' },
          { label: 'invoice_type', value: 'invoice_type', content: 'invoice_type' },
          { label: 'invoice_status', value: 'invoice_status', content: 'invoice_status' },
          { label: 'invoice_already_paid', value: 'invoice_already_paid', content: 'invoice_already_paid' },
          // Client data - full name
          { label: 'client_name', value: 'client_name', content: 'client_name' },
          // Client data - split names (compatible with login block)
          { label: 'firstname', value: 'firstname', content: 'firstname' },
          { label: 'lastname', value: 'lastname', content: 'lastname' },
          // Other client data
          { label: 'client_id', value: 'client_id', content: 'client_id' },
          { label: 'client_email', value: 'client_email', content: 'client_email' },
          { label: 'client_type', value: 'client_type', content: 'client_type' },
          { label: 'client_pid', value: 'client_pid', content: 'client_pid' },
          { label: 'business_name', value: 'business_name', content: 'business_name' },
          { label: 'business_address', value: 'business_address', content: 'business_address' },
          { label: 'business_reg_code', value: 'business_reg_code', content: 'business_reg_code' },
          // Lawyer/Partner data
          { label: 'partner_crm_id', value: 'partner_crm_id', content: 'partner_crm_id' },
          { label: 'partner_name', value: 'partner_name', content: 'partner_name' },
          { label: 'partner_email', value: 'partner_email', content: 'partner_email' },
          { label: 'partner_company_name', value: 'partner_company_name', content: 'partner_company_name' },
          { label: 'partner_company_address', value: 'partner_company_address', content: 'partner_company_address' },
          { label: 'partner_company_reg_id', value: 'partner_company_reg_id', content: 'partner_company_reg_id' },
          { label: 'partner_vat', value: 'partner_vat', content: 'partner_vat' },
          { label: 'partner_hourlyprice', value: 'partner_hourlyprice', content: 'partner_hourlyprice' },
          // Project data
          { label: 'related_project_id', value: 'related_project_id', content: 'related_project_id' },
          { label: 'related_project_no', value: 'related_project_no', content: 'related_project_no' },
        );
      }
      if (item.type === 'inputuploadBlock') {
        if (item.data?.variable) {
          variables.push({label: item.data.variable, value: item.data._id, content: item.data._id, id: item.data._id});
        }
        if (item.data?.uploadVariable) {
          variables.push({label: item.data.uploadVariable, value: item.data._id, content: item.data._id, id: item.data._id});
        }
      }
      if (item.type === 'aiBlock' && item.data?.outputMode === 'multiple' && item.data?.outputMappings?.length) {
        item.data.outputMappings.forEach((mapping) => {
          variables.push({
            label: mapping.variable,
            value: mapping.variable,
            content: mapping.variable
          });
        });
      }
      if (item.type === 'aiBlock' && item.data?.outputMode === 'doc' && item.data?.docVariable) {
        variables.push({
          label: item.data.docVariable,
          value: item.data.docVariable,
          content: item.data.docVariable,
        });
      }
    }
    // return item.type !== 'conditionBlock' && item.data?.hasOwnProperty('variable');
  });
  return variables;
};

const CHATBOT_PUT_FIELDS = [
  '_id',
  'name',
  'description',
  'img',
  'lang',
  'primaryLang',
  'status',
  'country',
  'start',
  'meta',
  'createdAt',
  'updatedAt',
  'createdBy',
  'progress',
  'preview',
  'gtmContainerId',
];

const pickChatbotPutPayload = (chatbot) => {
  const payload = {};
  CHATBOT_PUT_FIELDS.forEach((field) => {
    if (chatbot[field] !== undefined) {
      payload[field] = chatbot[field];
    }
  });
  return payload;
};

const set = async (data, callAPI = false) => {
  let response;
  if (allowApiCall(callAPI)) {
    const {blocks, ...chatbot} = getState().chatbot;
    const _chatbot = _defaultsDeep(data, chatbot);
    const payload = pickChatbotPutPayload(_chatbot);
    response = await axios.put(`/chatbot/${payload._id}`, payload);
  }
  dispatch(Actions.set(data));
  return response;
};


const setData = (data, callAPI = false) => {
  const _data = _defaultsDeep({data}, {data: getState().chatbot.data});
  if (callAPI) {
    axios.post(`/chatbot`, _data);
  }
  return dispatch(Actions.set(_data));
};



//Vaja eemaldada v hiljem kasutada
const getChatbot = (id) => {
  return getState().chatbot;
};
const setChatbotData = (id, data, prevdata, callAPI = true) => {


  var dataname = Object.getOwnPropertyNames(data)[0];
  var data2 = prevdata[dataname];


  const _data = prevdata.assign
  ? Object.assign({}, prevdata, data)
  : _defaultsDeep({data}, prevdata);
  
 
  const merged = Object.assign({}, data2, _data.data.progress)
  const data4 = {
  [dataname]: merged
  };
  logger.log(data4)
  

  if (allowApiCall(callAPI)) {
  //  logger.log('settingDATA: ' + id, _data.data)
    axios.saveBot(id, data4);
  }
  return dispatch(Actions.setChatbotData(data));
};


const setChatbotData0 = (id, data, callAPI = true) => {

 /*  logger.log(id, data)
  const prevdata = getChatbot();
  const _data = data.assign
  ? Object.assign({}, prevdata, data)
  : _defaultsDeep({data}, prevdata);
  
  logger.log(_data.data)

  if (callAPI) {
    axios.saveBot(id, _data.data);
  }
  return dispatch(Actions.setChatbotData0(data)); */


  dispatch(Actions.setChatbotData0(data));
  const prevdata = getChatbot();
  const updatedData = { ...prevdata, ...data };


  if (allowApiCall(callAPI)) {
    axios.saveBot(id, updatedData.data);
  }
  return; 

};



const getBlock = (id) => {
  return getState().chatbot.blocks[id];
};

const setBlock = (data) => {
  const block = _defaultsDeep(data, getBlock(data.id));
  return dispatch(Actions.setBlock(block));
};

const setBlocks = (blocks) => {
  dispatch(Actions.setBlocks(blocks));
  return blocks;
};

const removeBlockDecision = (blockId, id) => {
  return dispatch(Actions.removeBlockDecision({blockId, id}));
};
const removeBlockReviews = (blockId, id) => {
  return dispatch(Actions.removeBlockReviews({blockId, id}));
};
const removeSecondaryButton = (blockId, id) => {
  return dispatch(Actions.removeSecondaryButton({blockId, id}));
};
const removeBlockVariable = (blockId, id) => {
  return dispatch(Actions.removeBlockVariable({blockId, id}));
};
const removeGtmEcommerceProperty = (blockId, id) => {
  return dispatch(Actions.removeGtmEcommerceProperty({blockId, id}));
};
const removeGtmUserDataProperty = (blockId, id) => {
  return dispatch(Actions.removeGtmUserDataProperty({blockId, id}));
};
const removeGtmItem = (blockId, id) => {
  return dispatch(Actions.removeGtmItem({blockId, id}));
};
const removeGtmItemProperty = (blockId, itemId, id) => {
  return dispatch(Actions.removeGtmItemProperty({blockId, itemId, id}));
};
const removeBlockFlow = (blockId, id) => {
  return dispatch(Actions.removeBlockFlow({blockId, id}));
};

const removeAiRoute = (blockId, id) => {
  return dispatch(Actions.removeAiRoute({blockId, id}));
};

const removeRouterRoute = (blockId, id) => {
  return dispatch(Actions.removeRouterRoute({blockId, id}));
};

const removeDataBlock = (blockId, key) => {
  return dispatch(Actions.removeDataBlock({blockId, key}));
};

const removeBlockCondition = (blockId, id) => {
  return dispatch(Actions.removeBlockCondition({blockId, id}));
};

const clear = () => {
  dispatch(Actions.clear());
};

const setBlockData = async (id, data, callAPI = false) => {
  let response;

  const block = data.assign
    ? Object.assign({}, getBlock(id), {data: data.assign})
    : _defaultsDeep({data}, getBlock(id));

  if (allowApiCall(callAPI)) {
    response = await axios.post(`/block/${block.data.type}`, block.data);
  }
  dispatch(Actions.setBlockData(block));
  return response;
};

const removeBlock = async (id, callAPI = false) => {
  logger.log("KUSTUTA ID: " , id)
  if (allowApiCall(callAPI)) {
    axios.delete('/block', {id});
  }
  return dispatch(Actions.removeBlock(id));
};

const fetch = async (chatbotId) => {
  try {
    let {chatbot} = await axios.get(`/chatbot/${chatbotId}`);
    const blocks = formatBlocks(chatbot);
    return {...chatbot, blocks: blocks};
  } catch (error) {
    logger.error(error);
  }
};

const formatBlocks = (chatbot) => {
  let blocks = {};
  chatbot.blocks.forEach((block) => {
    if (block.type === 'handle') {
      blocks[block._id] = {
        ...block.meta.handle,
        data: {type: 'handle'},
      };
    } else {
      blocks[block._id] = {
        id: block._id,
        type: `${block.type}Block`,
        position: block.meta.position,
        data: block,
      };
    }
  });
  return blocks;
};

const fetchDocuments = async () => {
  try {
    const {documents} = await axios.get('user/documents');
    return {documents};
  } catch (error) {
    return error;
  }
};
const fetchSheets = async () => {
  try {
    const {documents} = await axios.get('user/sheets');
    return {documents};
  } catch (error) {
    return error;
  }
};

export const Chatbot = {
  get,
  set,
  setData,
  clear,
  setSuppressApiWrites,
  fetch,
  getBlock,
  setBlock,
  setBlockData,
  setBlocks,
  removeBlockDecision,
  removeBlockReviews,
  removeBlockCondition,
  removeBlock,
  getBlockVariables,
  getFileVariables,
  fetchDocuments,
  fetchSheets,
  removeDataBlock,
  formatBlocks,
  removeBlockFlow,
  removeAiRoute,
  removeRouterRoute,
  removeBlockVariable,
  removeGtmEcommerceProperty,
  removeGtmUserDataProperty,
  removeGtmItem,
  removeGtmItemProperty,
  removeSecondaryButton,
  getBlocksToReview,
  getChatbot, 
  setChatbotData,
  setChatbotData0,
};
